export default __webpack_public_path__ + "static/media/SDG4.41225a67.png";